import * as React from 'react';
import { PatternFormat, NumericFormat } from 'react-number-format';
import { TextInput } from '../../TextInput/src/TextInput.js';

const isPatternFormat = (format) => typeof format === 'string';
const NumberInputView = React.forwardRef((props, ref) => {
    const { format, thousandSeparator, decimalSeparator, decimalScale, fixedDecimalScale, allowNegative = false, allowedDecimalSeparators = [',', '.'], step, ...restProps } = props;
    if (isPatternFormat(format)) {
        return React.createElement(PatternFormat, { ...restProps, getInputRef: ref, format: format, customInput: TextInput });
    }
    return (React.createElement(NumericFormat, { ...restProps, getInputRef: ref, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator, decimalScale: decimalScale, fixedDecimalScale: fixedDecimalScale, allowNegative: allowNegative, allowedDecimalSeparators: allowedDecimalSeparators, customInput: TextInput }));
});

export { NumberInputView };
//# sourceMappingURL=NumberInputView.js.map
